import moment from "moment";
import { formattedBoxOfficeRegions } from "../../../../config-global";

const createBoxOfficeUrl = ({
  occasion = "",
  region = "",
  startDate = "",
  endDate = "",
}) => {
  return `boxoffice/grosstimeseries?occasion=${occasion}&region=${region}&startDate=${startDate}&endDate=${endDate}`;
};

const truncateLongText  = (text, maxLength = 30) => (
  text.length >= maxLength ? text.slice(0, maxLength - 3) + '...': text
)

const capitalize =(str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const filterRegionsByOccassion= (occasion) => {
  if (!occasion) {
    return [];
  }
  if (occasion === "daily") {
    return formattedBoxOfficeRegions[0].options.filter(
      (d) => d.value === "XDOM",
    );
  }
  if (occasion === "weekly") {
    return formattedBoxOfficeRegions[0].options.filter(
      (d) => d.value === "XDOM" || d.value === "XWW",
    );
  }
  if (occasion === "weekend") {
    return formattedBoxOfficeRegions;
  }
  return [];
}

const extractGreatestEndDate = ({ payload }) => {
  let greatestEndDate = "";
  if (payload?.length <= 0) return 0;
  payload?.map((item) => {
    item.grossTimeseries.map((series) => {
      if (
        !greatestEndDate ||
        new Date(series.endDate) > new Date(greatestEndDate)
      ) {
        greatestEndDate = series.endDate;
      }
    });
  });

  return greatestEndDate;
};
// Measured Oct 2026: a day, week or weekend reaches the backend about 2 days after
// it ends (Oct 2 had daily data through Sep 30, weekends through Sep 27, domestic
// weeks through Sep 24). Periods inside this window are not offered by default.
const REPORTING_LAG_DAYS = 2;

// A period this many days past its end with no data is "not reported", and no
// longer "not available yet".
const RECENT_PERIOD_DAYS = 14;

const isRecentPeriod = (endDate) =>
  moment().startOf("day").diff(moment(endDate).startOf("day"), "days") <= RECENT_PERIOD_DAYS;

const defaultDateRange = {
  type: "absolute",
  startDate: moment().subtract(14 + REPORTING_LAG_DAYS, "days").startOf("day").format("YYYY-MM-DD"),
  endDate: moment().subtract(REPORTING_LAG_DAYS, "days").startOf("day").format("YYYY-MM-DD"),
};

export { createBoxOfficeUrl, truncateLongText, filterRegionsByOccassion, extractGreatestEndDate, capitalize, defaultDateRange, REPORTING_LAG_DAYS, isRecentPeriod };
